// All 25 natures with their boosted/reduced stat
export const NATURE_TABLE = {
  Hardy:   { boost: null,               reduce: null },
  Lonely:  { boost: 'attack',           reduce: 'defense' },
  Brave:   { boost: 'attack',           reduce: 'speed' },
  Adamant: { boost: 'attack',           reduce: 'specialAttack' },
  Naughty: { boost: 'attack',           reduce: 'specialDefense' },
  Bold:    { boost: 'defense',          reduce: 'attack' },
  Docile:  { boost: null,               reduce: null },
  Relaxed: { boost: 'defense',          reduce: 'speed' },
  Impish:  { boost: 'defense',          reduce: 'specialAttack' },
  Lax:     { boost: 'defense',          reduce: 'specialDefense' },
  Timid:   { boost: 'speed',            reduce: 'attack' },
  Hasty:   { boost: 'speed',            reduce: 'defense' },
  Serious: { boost: null,               reduce: null },
  Jolly:   { boost: 'speed',            reduce: 'specialAttack' },
  Naive:   { boost: 'speed',            reduce: 'specialDefense' },
  Modest:  { boost: 'specialAttack',    reduce: 'attack' },
  Mild:    { boost: 'specialAttack',    reduce: 'defense' },
  Quiet:   { boost: 'specialAttack',    reduce: 'speed' },
  Rash:    { boost: 'specialAttack',    reduce: 'specialDefense' },
  Bashful: { boost: null,               reduce: null },
  Calm:    { boost: 'specialDefense',   reduce: 'attack' },
  Gentle:  { boost: 'specialDefense',   reduce: 'defense' },
  Sassy:   { boost: 'specialDefense',   reduce: 'speed' },
  Careful: { boost: 'specialDefense',   reduce: 'specialAttack' },
  Quirky:  { boost: null,               reduce: null },
};

export const NATURES = Object.keys(NATURE_TABLE);

// Common competitive sets for the 34 Pokémon in competitivePokemon.js
// showdownName: the exact name to pass to @smogon/calc
export const COMMON_SETS = {
  'dragapult': {
    showdownName: 'Dragapult',
    nature: 'Timid',
    item: 'Choice Specs',
    ability: 'Clear Body',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'chien-pao': {
    showdownName: 'Chien-Pao',
    nature: 'Jolly',
    item: 'Choice Band',
    ability: 'Sword of Ruin',
    evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
  },
  'iron-bundle': {
    showdownName: 'Iron Bundle',
    nature: 'Timid',
    item: 'Choice Specs',
    ability: 'Quark Drive',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'gholdengo': {
    showdownName: 'Gholdengo',
    nature: 'Modest',
    item: 'Choice Specs',
    ability: 'Good as Gold',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'flutter-mane': {
    showdownName: 'Flutter Mane',
    nature: 'Timid',
    item: 'Choice Specs',
    ability: 'Protosynthesis',
    evs: { hp: 0, atk: 0, def: 0, spa: 252, spd: 4, spe: 252 },
  },
  'walking-wake': {
    showdownName: 'Walking Wake',
    nature: 'Timid',
    item: 'Choice Specs',
    ability: 'Protosynthesis',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'iron-valiant': {
    showdownName: 'Iron Valiant',
    nature: 'Timid',
    item: 'Choice Specs',
    ability: 'Quark Drive',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'chi-yu': {
    showdownName: 'Chi-Yu',
    nature: 'Modest',
    item: 'Choice Specs',
    ability: 'Beads of Ruin',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'roaring-moon': {
    showdownName: 'Roaring Moon',
    nature: 'Jolly',
    item: 'Choice Band',
    ability: 'Protosynthesis',
    evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
  },
  'iron-moth': {
    showdownName: 'Iron Moth',
    nature: 'Modest',
    item: 'Choice Specs',
    ability: 'Quark Drive',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'dragonite': {
    showdownName: 'Dragonite',
    nature: 'Adamant',
    item: 'Choice Band',
    ability: 'Multiscale',
    evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
  },
  'volcarona': {
    showdownName: 'Volcarona',
    nature: 'Timid',
    item: 'Heavy-Duty Boots',
    ability: 'Flame Body',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'meowscarada': {
    showdownName: 'Meowscarada',
    nature: 'Jolly',
    item: 'Choice Band',
    ability: 'Protean',
    evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
  },
  'great-tusk': {
    showdownName: 'Great Tusk',
    nature: 'Jolly',
    item: 'Leftovers',
    ability: 'Protosynthesis',
    evs: { hp: 252, atk: 4, def: 0, spa: 0, spd: 252, spe: 0 },
  },
  'skeledirge': {
    showdownName: 'Skeledirge',
    nature: 'Modest',
    item: 'Leftovers',
    ability: 'Unaware',
    evs: { hp: 252, atk: 0, def: 0, spa: 252, spd: 4, spe: 0 },
  },
  'calyrex-ice-rider': {
    showdownName: 'Calyrex-Ice',
    nature: 'Adamant',
    item: 'Choice Band',
    ability: 'As One (Glastrier)',
    evs: { hp: 252, atk: 252, def: 4, spa: 0, spd: 0, spe: 0 },
  },
  'calyrex-shadow-rider': {
    showdownName: 'Calyrex-Shadow',
    nature: 'Timid',
    item: 'Choice Specs',
    ability: 'As One (Spectrier)',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'koraidon': {
    showdownName: 'Koraidon',
    nature: 'Jolly',
    item: 'Choice Band',
    ability: 'Orichalcum Pulse',
    evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
  },
  'miraidon': {
    showdownName: 'Miraidon',
    nature: 'Timid',
    item: 'Choice Specs',
    ability: 'Hadron Engine',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'iron-hands': {
    showdownName: 'Iron Hands',
    nature: 'Brave',
    item: 'Assault Vest',
    ability: 'Quark Drive',
    evs: { hp: 252, atk: 252, def: 4, spa: 0, spd: 0, spe: 0 },
  },
  'scream-tail': {
    showdownName: 'Scream Tail',
    nature: 'Timid',
    item: 'Choice Scarf',
    ability: 'Protosynthesis',
    evs: { hp: 252, atk: 0, def: 0, spa: 0, spd: 4, spe: 252 },
  },
  'kyogre': {
    showdownName: 'Kyogre',
    nature: 'Modest',
    item: 'Choice Specs',
    ability: 'Drizzle',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'groudon': {
    showdownName: 'Groudon',
    nature: 'Adamant',
    item: 'Life Orb',
    ability: 'Drought',
    evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
  },
  'ho-oh': {
    showdownName: 'Ho-Oh',
    nature: 'Adamant',
    item: 'Heavy-Duty Boots',
    ability: 'Regenerator',
    evs: { hp: 252, atk: 252, def: 4, spa: 0, spd: 0, spe: 0 },
  },
  'lugia': {
    showdownName: 'Lugia',
    nature: 'Timid',
    item: 'Heavy-Duty Boots',
    ability: 'Multiscale',
    evs: { hp: 252, atk: 0, def: 252, spa: 0, spd: 4, spe: 0 },
  },
  'lunala': {
    showdownName: 'Lunala',
    nature: 'Timid',
    item: 'Choice Specs',
    ability: 'Shadow Shield',
    evs: { hp: 4, atk: 0, def: 0, spa: 252, spd: 0, spe: 252 },
  },
  'zacian-crowned': {
    showdownName: 'Zacian-Crowned',
    nature: 'Jolly',
    item: 'Rusted Sword',
    ability: 'Intrepid Sword',
    evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
  },
  'zamazenta-crowned': {
    showdownName: 'Zamazenta-Crowned',
    nature: 'Jolly',
    item: 'Rusted Shield',
    ability: 'Dauntless Shield',
    evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
  },
  'urshifu-rapid-strike': {
    showdownName: 'Urshifu-Rapid-Strike',
    nature: 'Adamant',
    item: 'Choice Band',
    ability: 'Unseen Fist',
    evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
  },
  'urshifu-single-strike': {
    showdownName: 'Urshifu',
    nature: 'Adamant',
    item: 'Choice Band',
    ability: 'Unseen Fist',
    evs: { hp: 4, atk: 252, def: 0, spa: 0, spd: 0, spe: 252 },
  },
  'incineroar': {
    showdownName: 'Incineroar',
    nature: 'Careful',
    item: 'Assault Vest',
    ability: 'Intimidate',
    evs: { hp: 252, atk: 68, def: 0, spa: 0, spd: 188, spe: 0 },
  },
  'rillaboom': {
    showdownName: 'Rillaboom',
    nature: 'Adamant',
    item: 'Choice Band',
    ability: 'Grassy Surge',
    evs: { hp: 252, atk: 252, def: 4, spa: 0, spd: 0, spe: 0 },
  },
  'amoonguss': {
    showdownName: 'Amoonguss',
    nature: 'Sassy',
    item: 'Rocky Helmet',
    ability: 'Regenerator',
    evs: { hp: 252, atk: 0, def: 4, spa: 0, spd: 252, spe: 0 },
  },
};

// Curated item list for dropdowns, grouped
export const ITEM_GROUPS = {
  'Offensive': [
    'Choice Band', 'Choice Specs', 'Choice Scarf',
    'Life Orb', 'Booster Energy', 'Expert Belt',
    'Muscle Band', 'Wise Glasses',
    'Rusted Sword', 'Rusted Shield',
    // Type plates / held items
    'Black Glasses', 'Charcoal', 'Mystic Water', 'Miracle Seed',
    'Twisted Spoon', 'Dragon Fang', 'Metal Coat', 'Hard Stone',
    'Silk Scarf', 'Poison Barb', 'Soft Sand', 'Never-Melt Ice',
    'Sharp Beak', 'Magnet', 'Pink Bow', 'Silver Powder', 'Spell Tag',
  ],
  'Defensive': [
    'Assault Vest', 'Eviolite', 'Rocky Helmet',
    'Focus Sash', 'Sitrus Berry', 'Leftovers',
    'Safety Goggles', 'Clear Amulet', 'Mirror Herb',
    'Lum Berry', 'Chesto Berry', 'Weakness Policy',
  ],
  'Utility': [
    'Heavy-Duty Boots', 'Mental Herb', 'Power Herb',
    'Air Balloon', 'Red Card', 'Shed Shell',
    'Wide Lens', 'Zoom Lens',
  ],
  'None': ['None'],
};

// Weather options for @smogon/calc
export const WEATHER_OPTIONS = [
  'None', 'Sun', 'Rain', 'Sand', 'Snow',
  'Harsh Sunshine', 'Heavy Rain', 'Strong Winds',
];

// Terrain options
export const TERRAIN_OPTIONS = [
  'None', 'Electric', 'Grassy', 'Misty', 'Psychic',
];

// Pokemon whose presence strongly implies a specific weather
export const WEATHER_SETTERS = {
  'Kyogre':       'Rain',
  'Iron Bundle':  'Rain',
  'Urshifu-Rapid-Strike': 'Rain',
  'Groudon':      'Sun',
  'Ho-Oh':        'Sun',
  'Walking Wake': 'Sun',
  'Chi-Yu':       'Sun',
  'Iron Moth':    'Sun',
  'Volcarona':    'Sun',
  'Skeledirge':   'Sun',
};

// Pokemon whose presence strongly implies a specific terrain
export const TERRAIN_SETTERS = {
  'Rillaboom':   'Grassy',
  'Miraidon':    'Electric',
  'Scream Tail': 'Psychic',
};

// Move type → likely weather (for scenario generation)
export const MOVETYPE_WEATHER = {
  'Water': 'Rain',
  'Fire':  'Sun',
  'Ice':   'Snow',
};

// All 18 types for Tera selector
export const TYPES = [
  'Normal', 'Fire', 'Water', 'Electric', 'Grass', 'Ice',
  'Fighting', 'Poison', 'Ground', 'Flying', 'Psychic', 'Bug',
  'Rock', 'Ghost', 'Dragon', 'Dark', 'Steel', 'Fairy',
];
